import { render, staticRenderFns } from "./solicitud.vue?vue&type=template&id=537638bd&scoped=true"
import script from "./solicitud.vue?vue&type=script&lang=js"
export * from "./solicitud.vue?vue&type=script&lang=js"
import style0 from "./solicitud.vue?vue&type=style&index=0&id=537638bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537638bd",
  null
  
)

export default component.exports